import React from "react";
import {
    BrowserRouter as Router,
    Route,
    Switch,
    Redirect,
    useLocation
} from "react-router-dom";
import { Helmet } from "react-helmet";
import { inject, observer } from "mobx-react";
import { LLHeader } from "../../layout";
import MenuSetter from "../../layout/header/menu/menu-setter";
import { trans } from "../utils";
import {
    LoginPage,
    HomePage,
    ResetUsersGridSettingsPage,
    ChangePasswordPage,

    IncomePercentPage,
    ServiceProviderBalancePage,
    PayerPage,
    ServicePage,
    ProviderServicePage,
    Pay2PlayPinCodePage,

    LogsPage,
    LogCurrencyPage,
    LogEmailMessagePage,
    LogIncomePercentPage,
    LogPayerPage,
    LogServicePage,
    LogServiceProviderDataExchangePage,
    LogTransactionServiceProviderStatusPage,
    LogVerifyQueryPage,
    LogPinCodePage,

    MenuEditPage,
    MenuTreePage,
    MenuOperationPage,
    MenuSubPage,

    EmailMessageTemplatePage,
    CurrencyPage,

    TransactionPaymentProviderPage,
    TransactionServiceProviderPage,


    FileManagerPage
} from "../../pages";
import RouteGuard from "../../RouteGuard";



const LLRouter = inject("store")(
    observer(({ store }) => {
        const PageSetter = ({ activeMenu, Page }) => (
            <MenuSetter activeMenu={activeMenu}>
                <Helmet>
                    <title>{`Pay2Play - ${trans(useLocation().pathname)}`}</title>
                </Helmet>
                <Page />
            </MenuSetter>
        );

        return (
            <Router>
                {store.user.isLogged() && <LLHeader />}
                <div
                    className="site-content"
                    data-lang={store.languages.active}
                    data-scroll={store.scroll.type}
                >
                    {store.user.isLogged() ? (
                        <Switch>
                            <Route
                                path="/"
                                exact
                                component={() => (
                                    <PageSetter
                                        activeMenu="null"
                                        Page={HomePage}
                                    />
                                )}
                            />


                            <Route
                                path="/account/reset-settings"
                                component={() => (
                                    <PageSetter
                                        activeMenu="Account"
                                        Page={ResetUsersGridSettingsPage}
                                    />
                                )}
                            />
                            <Route
                                path="/account/change-password"
                                component={() => (
                                    <PageSetter
                                        activeMenu="Account"
                                        Page={ChangePasswordPage}
                                    />
                                )}
                            />



                            <Route
                                path="/info/income-percent"
                                component={() => (
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={IncomePercentPage}
                                    />
                                )}
                            />
                            <Route
                                path="/info/payer"
                                component={() => (
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={PayerPage}
                                    />
                                )}
                            />
                            <Route
                                path="/info/service"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={ServicePage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/info/provider-service"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={ProviderServicePage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/info/pay2play-pincode"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={Pay2PlayPinCodePage}
                                    />
                                    </RouteGuard>
                                )}
                            />




                            <Route
                                path="/logs/main"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={LogsPage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/logs/currency"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={LogCurrencyPage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/logs/email-messages"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={LogEmailMessagePage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/logs/income-percent"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={LogIncomePercentPage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/logs/payer"
                                component={() => (
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={LogPayerPage}
                                    />
                                )}
                            />
                            <Route
                                path="/logs/service"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={LogServicePage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/logs/service-provider-data-exchange"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={LogServiceProviderDataExchangePage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/logs/transaction-service-provider-status"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={LogTransactionServiceProviderStatusPage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/logs/pin-code"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={LogPinCodePage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/logs/verify-query"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={LogVerifyQueryPage}
                                    />
                                    </RouteGuard>
                                )}
                            />



                            <Route
                                path="/menu/main"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={MenuEditPage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/menu/tree"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={MenuTreePage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/menu/operation"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={MenuOperationPage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/menu/sub"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={MenuSubPage}
                                    />
                                    </RouteGuard>
                                )}
                            />





                            <Route
                                path="/settings/currency"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={CurrencyPage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/settings/email-message-template"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={EmailMessageTemplatePage}
                                    />
                                    </RouteGuard>
                                )}
                            />



                            <Route
                                path="/transaction/payment-provider"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator','ServiceProvider']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={TransactionPaymentProviderPage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/transaction/service-provider"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator','ServiceProvider']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={TransactionServiceProviderPage}
                                    />
                                    </RouteGuard>
                                )}
                            />


                            <Route
                                path="/file-manager/cdn"
                                component={() => (
                                    <RouteGuard allowedRoles={['Administrator']}>
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={FileManagerPage}
                                    />
                                    </RouteGuard>
                                )}
                            />
                            <Route
                                path="/info/service-provider-balance"
                                component={() => (
                                    <PageSetter
                                        activeMenu={`${trans(useLocation().pathname)}`}
                                        Page={ServiceProviderBalancePage}
                                    />

                                )}
                            />



                        </Switch>
                    ) : (
                            <Switch>
                                <Route
                                    exact
                                    path="/user/login"
                                    component={() => (
                                        <PageSetter
                                            activeMenu={null}
                                            Page={LoginPage}
                                        />
                                    )}
                                />
                                <Route
                                    path="*"
                                    render={() => <Redirect to="/user/login" />}
                                />
                            </Switch>
                        )}
                </div>
            </Router>
        );
    }),
);

export default LLRouter;
